import { useState } from "react"

// Five stars. Pass onChange to make it an input; without it, it's display-only.
// Spans instead of buttons so the global button styles don't apply to each star.
export default function StarRating({ value = 0, onChange, size = 24 }) {
    const [hover, setHover] = useState(0)
    const interactive = !!onChange
    const shown = hover || value

    return (
        <div
            className="flex center"
            style={{ gap: 2 }}
            role={interactive ? "radiogroup" : "img"}
            aria-label={interactive ? "Rating" : `${value} out of 5 stars`}
            onMouseLeave={() => setHover(0)}
        >
            {[1, 2, 3, 4, 5].map(n => (
                <span
                    key={n}
                    role={interactive ? "radio" : undefined}
                    aria-checked={interactive ? value === n : undefined}
                    aria-label={interactive ? `${n} ${n === 1 ? "star" : "stars"}` : undefined}
                    tabIndex={interactive ? 0 : undefined}
                    onClick={interactive ? () => onChange(n) : undefined}
                    onKeyDown={interactive ? (e) => {
                        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onChange(n) }
                    } : undefined}
                    onMouseEnter={interactive ? () => setHover(n) : undefined}
                    style={{
                        fontSize: size,
                        lineHeight: 1,
                        cursor: interactive ? "pointer" : "default",
                        color: "rgb(var(--accent))",
                        opacity: n <= shown ? 1 : 0.25,
                    }}
                >★</span>
            ))}
        </div>
    )
}